import {
  Box,
  Button,
  Center,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  GridItem,
  Image,
  Input,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Switch,
  Text,
} from "@chakra-ui/react";
import { FC, ReactNode } from "react";
import { TApplicationDetail } from "../../../../@types/Application";
import copy from "../../../../images/copy-icon.svg";
import buttonNext from "../../../../images/icons/button_next.svg";
import { useEditApplication } from "../../../../lib/hooks/ManagementSettings/useEditApplication";
import { CommonModal } from "../../CommonModal";
import { ButtonSubmit } from "../Button/ButtonSubmit";
import { categoryOptions } from "lib/Const";

export type EditApplicationModalProps = {
  applicationSelected?: TApplicationDetail | null;
  title: ReactNode;
  isOpen: boolean;
  isRegistered?: boolean;
  onClose: (props?: { isFetchData?: boolean }) => void;
};

export const EditApplicationModal: FC<EditApplicationModalProps> = (props) => {
  const { isOpen, title, onClose, applicationSelected } = props;
  const { state, handler } = useEditApplication(props);

  return (
    <CommonModal
      isOpen={isOpen}
      title={title}
      onClose={() => {
        handler?.reset();
        onClose?.();
      }}
      minW={500}
      isCentered
      overflowBody="hidden"
    >
      <form
        onSubmit={handler?.handleSubmit(handler?.onSubmit, (error) => {
          console.error({ error });
        })}
        autoComplete="off"
      >
        <Flex direction="column" rowGap="40px" justifyContent="flex-start">
          <GridItem>
            {applicationSelected?.applicationName ? (
              <Flex direction="column" justify="center" gap="16px">
                <Text fontWeight="700" color="#2C2C2C" fontSize="16px">
                  実行ファイル名
                </Text>
                <Text fontWeight="500" color="#2C2C2C" fontSize="16px">
                  {applicationSelected?.applicationExecuteName}
                </Text>
              </Flex>
            ) : (
              <FormControl isInvalid={!!state?.formState?.errors.executeName}>
                <FormLabel mb="16px">
                  <Text fontWeight="700" color="#2C2C2C" fontSize="16px">
                    実行ファイル名
                  </Text>
                </FormLabel>
                <Input
                  disabled={state?.loading}
                  variant="custom"
                  maxLength={100}
                  {...handler?.register("executeName")}
                />
                <FormErrorMessage fontSize="14px">
                  {state?.formState?.errors.executeName &&
                    state?.formState?.errors.executeName.message}
                </FormErrorMessage>
              </FormControl>
            )}
          </GridItem>

          <GridItem>
            <FormControl isInvalid={!!state?.formState?.errors.name}>
              <FormLabel mb="16px">
                <Text fontWeight="700" color="#2C2C2C" fontSize="16px">
                  アプリケーション名
                </Text>
              </FormLabel>
              <Input
                disabled={state?.loading}
                variant="custom"
                maxLength={100}
                {...handler?.register("name")}
              />
              <FormErrorMessage fontSize="14px">
                {state?.formState?.errors.name &&
                  state?.formState?.errors.name.message}
              </FormErrorMessage>
            </FormControl>
          </GridItem>

          <GridItem
            css={{
              width: "fit-content",
              maxWidth: "60%",
              minWidth: "45%",
            }}
          >
            <FormLabel mb="16px">
              <Text fontWeight="700" color="#2C2C2C" fontSize="16px">
                カテゴリ
              </Text>
            </FormLabel>
            <Menu>
              <MenuButton
                as={Button}
                rightIcon={
                  <Image
                    src={buttonNext}
                    alt="icon-select"
                    width="8px"
                    transform="rotate(90deg)"
                  />
                }
                borderRadius="10px"
                height="34px"
                width="100%"
                textAlign="justify"
                background="white !important"
                border="1px solid #B1B1B1"
                fontSize="12px"
                borderColor={
                  state?.formState?.errors?.applicationType
                    ? "#E53E3E"
                    : "#B1B1B1"
                }
                boxShadow={
                  state?.formState?.errors?.applicationType
                    ? "0 0 0 1px #E53E3E"
                    : "unset"
                }
              >
                {(categoryOptions as any)?.[handler?.watch("applicationType")]
                  ?.name || "カテゴリを選択してください"}
              </MenuButton>
              <MenuList
                borderRadius="10px"
                boxShadow="md"
                border="1px solid gray"
              >
                {Object.values(categoryOptions).map((value) => (
                  <MenuItem
                    key={value?.value}
                    onClick={() => {
                      handler?.setValue?.(
                        "applicationType",
                        value?.value?.toString(),
                        {
                          shouldValidate: true,
                        }
                      );
                    }}
                    fontSize="12px"
                  >
                    {value?.name}
                  </MenuItem>
                ))}
              </MenuList>
            </Menu>
            {state?.formState?.errors.applicationType?.message ? (
              <Text fontSize="14px" color="#E53E3E" marginTop="0.5rem">
                {state?.formState?.errors.applicationType.message}
              </Text>
            ) : null}
          </GridItem>

          {state?.applicationTypeValue?.toString() !==
            categoryOptions?.secret?.value &&
          state?.applicationTypeValue?.toString() &&
          state?.applicationTypeValue?.toString() !==
            props?.applicationSelected?.applicationType?.toString() &&
          state?.listUser?.length ? (
            <Flex
              direction="column"
              marginBlock="-20px"
              gap="12px"
              position="relative"
            >
              <Flex gap="8px" align="center">
                <svg
                  width="31.77"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 15C10.2833 15 10.5208 14.9042 10.7125 14.7125C10.9042 14.5208 11 14.2833 11 14C11 13.7167 10.9042 13.4792 10.7125 13.2875C10.5208 13.0958 10.2833 13 10 13C9.71667 13 9.47917 13.0958 9.2875 13.2875C9.09583 13.4792 9 13.7167 9 14C9 14.2833 9.09583 14.5208 9.2875 14.7125C9.47917 14.9042 9.71667 15 10 15ZM9 11H11V5H9V11ZM10 20C8.61667 20 7.31667 19.7375 6.1 19.2125C4.88333 18.6875 3.825 17.975 2.925 17.075C2.025 16.175 1.3125 15.1167 0.7875 13.9C0.2625 12.6833 0 11.3833 0 10C0 8.61667 0.2625 7.31667 0.7875 6.1C1.3125 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.3125 6.1 0.7875C7.31667 0.2625 8.61667 0 10 0C11.3833 0 12.6833 0.2625 13.9 0.7875C15.1167 1.3125 16.175 2.025 17.075 2.925C17.975 3.825 18.6875 4.88333 19.2125 6.1C19.7375 7.31667 20 8.61667 20 10C20 11.3833 19.7375 12.6833 19.2125 13.9C18.6875 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6875 13.9 19.2125C12.6833 19.7375 11.3833 20 10 20Z"
                    fill="#FFC700"
                  />
                </svg>
                <Text fontSize="12px" fontWeight="700" color="#FF4B45">
                  このアプリケーションのカテゴリをシークレットに設定しているメンバーがいます。本当にカテゴリを変更しますか？
                </Text>
              </Flex>
              <Box
                gap="8px"
                border="1px solid #D5D5D5"
                padding="10px"
                paddingLeft="20px"
                paddingRight="30px"
                maxHeight="84px"
                minHeight="84px"
                overflowY="auto"
                borderRadius="10px"
              >
                {state?.listUser?.map((value, index) => {
                  return (
                    <Flex
                      key={index}
                      direction="column"
                      color="#2C2C2C"
                      fontWeight="500"
                      fontSize="12px"
                    >
                      <Box>{value}</Box>
                    </Flex>
                  );
                })}
              </Box>
              <Image
                src={copy}
                h="24px"
                w="24px"
                position="absolute"
                bottom="8px"
                right="24px"
                cursor="pointer"
                onClick={() => handler?.onCopy()}
              />
            </Flex>
          ) : null}

          <GridItem>
            <FormControl
              isInvalid={!!state?.formState?.errors.typing}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width="65%"
            >
              <FormLabel mb="0" paddingRight="20px">
                <Text fontWeight="700" color="#2C2C2C" fontSize="16px">
                  キー入力内容の記録
                </Text>
              </FormLabel>
              <Switch
                colorScheme="green"
                {...handler?.register("typing")}
                _checked={{
                  ".chakra-switch__track": {
                    background: "#00BA0F",
                    boxShadow: "none",
                    _hover: {
                      background: "#00BA0F",
                    },
                  },
                  ".chakra-switch__thumb": {
                    left: "calc(100% - 27.6px)",
                    transform: "translateX(0px)",
                  },
                }}
                css={{
                  ".chakra-switch__track": {
                    boxShadow: "none",
                    height: "28px",
                    width: "48px",
                    padding: "2px",
                  },
                  ".chakra-switch__thumb": {
                    height: "25.6px",
                    width: "25.6px",
                    top: "1.35px",
                    left: "2px",
                    position: "relative",
                  },
                }}
                boxShadow={"none"}
                disabled={state?.loading}
              />
              <FormErrorMessage fontSize="14px">
                {state?.formState?.errors.typing &&
                  state?.formState?.errors.typing.message}
              </FormErrorMessage>
            </FormControl>
          </GridItem>

          <GridItem>
            <FormControl
              isInvalid={!!state?.formState?.errors.capture}
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              width="65%"
            >
              <FormLabel mb="0" paddingRight="20px">
                <Text fontWeight="700" color="#2C2C2C" fontSize="16px">
                  スクリーンショットの記録
                </Text>
              </FormLabel>
              <Switch
                colorScheme="green"
                {...handler?.register("capture")}
                _checked={{
                  ".chakra-switch__track": {
                    background: "#00BA0F",
                    boxShadow: "none",
                    _hover: {
                      background: "#00BA0F",
                    },
                  },
                  ".chakra-switch__thumb": {
                    left: "calc(100% - 27.6px)",
                    transform: "translateX(0px)",
                  },
                }}
                css={{
                  ".chakra-switch__track": {
                    boxShadow: "none",
                    height: "28px",
                    width: "48px",
                    padding: "2px",
                  },
                  ".chakra-switch__thumb": {
                    height: "25.6px",
                    width: "25.6px",
                    top: "1.35px",
                    left: "2px",
                    position: "relative",
                  },
                }}
                boxShadow={"none"}
                disabled={state?.loading}
              />
              <FormErrorMessage fontSize="14px">
                {state?.formState?.errors.capture &&
                  state?.formState?.errors.capture.message}
              </FormErrorMessage>
            </FormControl>
          </GridItem>
        </Flex>
        {/* <Center pt="40px" pb="20px"> */}
        <Center pt="30px">
          <ButtonSubmit type="submit" isLoading={state?.loading}>
            確定
          </ButtonSubmit>
        </Center>
      </form>
    </CommonModal>
  );
};
